export default {
   billing_accounts_id: 'Id',
   billing_accounts_name: 'Nombre',
   billing_accounts_created_on: 'Creado el',
   billing_accounts_created_by: 'Creado por',
   billing_accounts_add_new: 'Añadir cuenta de facturación',
   billing_accounts_updated_on: 'Actualizado el',
   billing_accounts_updated_by: 'Actualizado por',
   billing_accounts_created_on: 'Creado el',
   billing_accounts_created_by: 'Creado por',
   billing_accounts_delete: 'Eliminar',
   billing_accounts_edit: 'Editar',
   billing_accounts_devices_assigned: 'Dispositivos asignados',
   billing_accounts_assigned_devices_title: 'Dispositivos asignados',
   billing_accounts_no_devices: 'No se encontraron dispositivos',
};